module.exports = __webpack_public_path__ + "static/media/sparkle.4dd71783.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sparkle.png
// module id = 120
// module chunks = 0